import { billingZones } from 'localizations';

import { BillingZone, LEGACY_EU_MAIN_UNMAPPED_COUNTRIES } from '../config';

// TODO: [1/l] In the future, the backend promises to add a method for obtaining the billing zone by country
export const getBillingZoneByCountry = (
  country: string,
): BillingZone | undefined => {
  if (billingZones['EU-UK'].countries.includes(country)) {
    return 'EU-UK';
  }

  if (billingZones['EU-SW'].countries.includes(country)) {
    return 'EU-SW';
  }

  if (
    billingZones['EU-MAIN'].countries.includes(country) &&
    !LEGACY_EU_MAIN_UNMAPPED_COUNTRIES.includes(country)
  ) {
    return 'EU-MAIN';
  }

  if (billingZones.CIS.countries.includes(country)) {
    return 'CIS';
  }

  if (billingZones['US-CA'].countries.includes(country)) {
    return 'US-CA';
  }

  if (country === 'US') {
    return 'US-IRB';
  }

  if (billingZones['US-LATAM'].countries.includes(country)) {
    return 'US-LATAM';
  }

  return undefined;
};
